import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {css} from '@emotion/react';

const activeState = theme => css`
  color: ${theme.secondaryFontColor};
  background-color: ${theme.primaryColor};
  font-weight: 800;
  box-shadow: none; 
`;

const RoundedButton = styled.button(
  ({ theme, active }) => css`
    height: 28px;
    width: auto;
    min-width: 80px;
    padding: 6px 16px;

    display: flex;
    justify-content: center;
    align-items: center;

    color: ${theme.primaryColor};
    background-color: ${theme.cardColor};

    font-size: 12px;
    font-family: ${theme.fontFamily};
    line-height: 16px;
    font-weight: 600;

    border-radius: 14px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;

    &:hover {
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.16);
    }

    cursor: pointer;

    ${active && activeState(theme)}
  `
);

RoundedButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

RoundedButton.defaultProps = {
  type: 'button',
  active: false,
};

export default RoundedButton;
